





































































































import Vue from 'vue'
import Component from "vue-class-component";
import {Getter, State} from "vuex-class";
import {onClear, removeOnClear, send, SignatureRequest} from "@/modules/sigcom";
import SignaturePad from "@/components/SignaturePad.vue";
import {Ref, Watch} from "vue-property-decorator";
import IdentityValidation from "@/components/IdentityValidation.vue";
import Message from "@/components/Message.vue";
import {AppConfigParameters} from "@/store";
import pdf from 'vue-pdf'

/**
 * Pantalla principal, muestra un mensaje mientras la aplicación se encuentra
 * a la espera de una nueva petición de firma y cuando recibe una muestra
 * el componente que permite al usuario dibujar su firma
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {Message, IdentityValidation, SignaturePad, pdf}
})
export default class Home extends Vue {
    /**
     * Referencia a la propiedad del estado que almacena la petición de firma
     * actualmente activa. Si no existe ninguna activa el valor será nulo.
     */
    @State
    public signatureRequest: SignatureRequest | null

    @Ref()
    public signature: SignaturePad

    /**
     * Indica si la aplicación tiene configurado algún documento para la protección
     * de datos.
     */
    @Getter('hasDataProtectionDocument')
    public hasDataProtectionDocument: boolean

    public get containerClasses () {
        return {
            'pt-0': !this.signatureRequest,
            'pt-9': this.signatureRequest,
            'mt-0': true,
            'd-flex': true,
            'align-center': true,
            'flex-column': true,
            'justify-center': !this.signatureRequest
        }
    }

    public firmarDocumento = false
    public step = 1
    public objectURL = ''
    public autoNext = true


    public currentPage = 1
    public documentPages = 0
    public numDocumento = ""
    public impDocumento = 0

    public get canAccept () {
        if (this.documentPages === 1) {
            return true
        }

        return this.currentPage === this.documentPages
    }

    /**
     * Observa la petición de firma actualmente mostrada, si no hay ninguna se oculta
     * la guía para firmar
     */
    @Watch('signatureRequest')
    public watchSignatureRequest (request: SignaturePad[] | null) {        
        this.numDocumento = ""
        this.impDocumento = 0
        if (request != null) {            
            this.numDocumento = request[0].documento
            this.impDocumento = request[0].importe
        }
        if (!request) {
                this.firmarDocumento = false
                this.step = 1
                this.currentPage = 1
                this.documentPages = 0
        }else{
            if (request != null && this.numDocumento != "")            
            {   
                this.step = 1
                this.currentPage = 1
                this.documentPages = 0
                this.firmarDocumento = true                
            }else{
                this.firmarDocumento = false
                this.step = 1
                this.currentPage = 1
                this.documentPages = 0
            }
        }
    }


    /**
     * Al crear el componente inicia la escucha de los eventos necesarios
     */
    public async created () {
        await onClear(() => {
            // La maquina de firmas ha solicitado que el area de dibujo sea
            // limpiada
            this.signature.clear()
        })
    }

    public getDataProtectionDocument () {
        if (this.objectURL) {
            return this.objectURL
        }

        const doc = this.$store.state.appConfig[AppConfigParameters.DataProtectionDocument]
        if (!doc) {
            return
        }

        const dataURL = doc.data
        const parts = dataURL.split(';base64,')
        const imageType = parts[0].split(':')[1]
        const decodedData = window.atob(parts[1]);
        const uInt8Array = new Uint8Array(decodedData.length);
        for (let i = 0; i < decodedData.length; ++i) {
            uInt8Array[i] = decodedData.charCodeAt(i);
        }

        const blob = new Blob([uInt8Array], { type: imageType });


        this.objectURL = URL.createObjectURL(blob)
        this.$forceUpdate()

        return this.objectURL
    }

    /**
     * Invoca el método send() del módulo sigcom para enviar la firma a la maquina
     * que se encuentre escuchando
     *
     * @param signature
     */
    public send (signature: {data: string}) {
        const data = signature.data ? signature.data : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII='
        send(data)
    }

    destroyed () {
        removeOnClear()
    }
}
